import React from "react";
import SiteHeader from "../components/SiteHeader";
import SiteFooter from "../components/SiteFooter";
import ScrollToTopButton from "../components/ScrollToTopButton";
import { toPersianDigits } from "../utils/persianDigits";

// Section A: public. "ارتباط با ما" — contact details pulled straight
// from the project's contactWithus file (phone, Telegram, Instagram,
// email), each a real tel:/mailto:/profile link.
const CONTACT_METHODS = [
  { label: "شماره تماس", value: toPersianDigits("09224901755"), href: "tel:09224901755" },
  { label: "تلگرام", value: "architecture_mag@", href: "https://t.me/architecture_mag" },
  { label: "اینستاگرام", value: "dariche_mag@", href: "https://instagram.com/dariche_mag" },
  {
    label: "ایمیل",
    value: "Daricheh.architecture.ut@gmail.com",
    href: "mailto:Daricheh.architecture.ut@gmail.com",
  },
];

function ContactPage() {
  return (
    <div className="site">
      <SiteHeader />

      <main>
        <section className="contact-hero">
          <span className="contact-hero-kicker">ارتباط با ما</span>
          <h1>گفت‌وگو با دریچه</h1>
          <p>برای همکاری، پیشنهاد، یا هر گفت‌وگوی دیگری، از راه‌های زیر با ما در ارتباط باشید.</p>
        </section>

        <section className="contact-card">
          <span className="corner corner-tr" />
          <span className="corner corner-tl" />
          <span className="corner corner-br" />
          <span className="corner corner-bl" />

          <ul className="contact-list">
            {CONTACT_METHODS.map((method) => (
              <li key={method.label}>
                <a
                  className="contact-row"
                  href={method.href}
                  target={method.href.startsWith("http") ? "_blank" : undefined}
                  rel={method.href.startsWith("http") ? "noreferrer" : undefined}
                >
                  <span className="contact-row-label">{method.label}</span>
                  <span className="contact-row-value">{method.value}</span>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </main>

      <SiteFooter />
      <ScrollToTopButton />
    </div>
  );
}

export default ContactPage;
